import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { Device } from 'src/app/models/centrex/device';
import { OrganizationsService } from '../organizations.service';
import { ServiceBase } from '../service-base';
import { BlfType } from 'src/app/models/centrex/blftype';

@Injectable({
    providedIn: 'root',
})
export class DeviceService extends ServiceBase {
    constructor(private http: HttpClient, private organizationsServices: OrganizationsService) {
        super();
    }

    getDevices(): Observable<Device[]> {
        const httpOptions = {
            headers: new HttpHeaders().set('X-OrganizationId', this.organizationsServices.getCurrentOrganization().id ?? ''),
        };

        return this.http.get<Device[]>(`${this.baseUrl}/api/devices`, httpOptions);
    }

    getDevice(deviceAddress: string): Observable<Device> {
        const httpOptions = {
            headers: new HttpHeaders().set('X-OrganizationId', this.organizationsServices.getCurrentOrganization().id ?? ''),
        };

        return this.http.get<Device>(`${this.baseUrl}/api/devices/${deviceAddress}`, httpOptions);
    }

    addDevice(device: Device, globalNotification = true): Observable<Device> {
        const httpOptions = {
            headers: new HttpHeaders()
                .set('Content-Type', 'application/json')
                .set('global-notification', String(globalNotification))
                .set('X-OrganizationId', this.organizationsServices.getCurrentOrganization().id ?? ''),
        };

        return this.http.post<Device>(`${this.baseUrl}/api/devices`, device, httpOptions);
    }

    updateDevice(device: Device): Observable<Device> {
        const httpOptions = {
            headers: new HttpHeaders().set('Content-Type', 'application/json').set('X-OrganizationId', this.organizationsServices.getCurrentOrganization().id ?? ''),
        };

        return this.http.patch<Device>(`${this.baseUrl}/api/devices/${device.address}`, device, httpOptions);
    }

    deleteDevice(deviceAddress: string) {
        const httpOptions = {
            headers: new HttpHeaders().set('X-OrganizationId', this.organizationsServices.getCurrentOrganization().id ?? ''),
        };

        return this.http.delete<Device>(`${this.baseUrl}/api/devices/${deviceAddress}`, httpOptions);
    }

    getDeviceConfig(deviceAddress: string): Observable<string> {
        const httpOptions = {
            headers: new HttpHeaders().set('X-OrganizationId', this.organizationsServices.getCurrentOrganization().id ?? ''),
        };

        return this.http.get<string>(`${this.baseUrl}/api/devices/${deviceAddress}/config`, httpOptions);
    }

    rebootDevice(deviceAddress: string) {
        const httpOptions = {
            headers: new HttpHeaders().set('X-OrganizationId', this.organizationsServices.getCurrentOrganization().id ?? ''),
        };

        return this.http.put<Device>(`${this.baseUrl}/api/devices/${deviceAddress}/notify/reboot`, '', httpOptions);
    }

    registerDevice(deviceAddress: string) {
        const httpOptions = {
            headers: new HttpHeaders().set('X-OrganizationId', this.organizationsServices.getCurrentOrganization().id ?? ''),
        };

        return this.http.put<Device>(`${this.baseUrl}/api/devices/${deviceAddress}/notify/register`, '', httpOptions);
    }

    provisionningDevice(deviceAddress: string) {
        const httpOptions = {
            headers: new HttpHeaders().set('X-OrganizationId', this.organizationsServices.getCurrentOrganization().id ?? ''),
        };

        return this.http.put<Device>(`${this.baseUrl}/api/devices/${deviceAddress}/notify/provisionning`, '', httpOptions);
    }

    getBlfsTypes(manufacturer: string): Observable<BlfType[]> {
        const httpOptions = {
            headers: new HttpHeaders().set('X-OrganizationId', this.organizationsServices.getCurrentOrganization().id ?? ''),
        };

        return this.http.get<BlfType[]>(`${this.baseUrl}/api/devices/blfstypes/${manufacturer}`, httpOptions);
    }
}
